import { useQuery } from '@tanstack/react-query';
import { useUserIdentityState } from '@provider/user-identity';
import { DAYS_TO_MS, HOURS_TO_MS } from '@utils/constants';
import { getStudentsInClass } from './request.get-students-in-class.js';

const getStudentsQueryKey = (user, classNames) => [
  "userdata/get-students",
  user == null ? void 0 : user.id,
  Object.fromEntries(classNames.map((it) => [it, true]))
];
const getStudentsInClassesQuery = (user, classNames) => {
  return {
    queryKey: getStudentsQueryKey(user, classNames),
    queryFn: async () => {
      const resolved = await Promise.all(
        classNames.map((className) => getStudentsInClass(user, className))
      );
      const knownStudentIds = /* @__PURE__ */ new Set();
      return resolved.flatMap((students) => students).filter((student) => {
        if (knownStudentIds.has(student.id)) {
          return false;
        }
        knownStudentIds.add(student.id);
        return true;
      });
    },
    staleTime: 8 * HOURS_TO_MS,
    gcTime: 7 * DAYS_TO_MS
  };
};
const useGetStudentsInClassesQuery = (classNames) => {
  const user = useUserIdentityState((state) => state.user);
  return useQuery(getStudentsInClassesQuery(user, classNames));
};

export { getStudentsInClassesQuery, getStudentsQueryKey, useGetStudentsInClassesQuery };
//# sourceMappingURL=query.get-students.js.map
